export function normalizeProductFromApi(product) {
  if (!product) return product

  const facts = product.facts || {}

  return {
    ...product,
    original_price: product.original_price != null ? product.original_price : product.price,
    discount_fact: facts.discount != null ? facts.discount : (product.discount_fact != null ? product.discount_fact : 0),
    tripoli_fact: facts.tripoli != null ? facts.tripoli : (product.tripoli_fact != null ? product.tripoli_fact : 1),
    misrata_fact: facts.misrata != null ? facts.misrata : (product.misrata_fact != null ? product.misrata_fact : (facts.tripoli != null ? facts.tripoli : 1)),
    benghazi_fact: facts.benghazi != null ? facts.benghazi : (product.benghazi_fact != null ? product.benghazi_fact : (facts.tripoli != null ? facts.tripoli : 1)),
  }
}

export function appendProductPricingToFormData(formData, pricing) {
  formData.set('original_price', pricing.original_price)
  formData.set('discount_fact', pricing.discount_fact != null && pricing.discount_fact !== '' ? pricing.discount_fact : 0)
  formData.set('tripoli_fact', pricing.tripoli_fact)
  formData.set('misrata_fact', pricing.misrata_fact != null && pricing.misrata_fact !== '' ? pricing.misrata_fact : pricing.tripoli_fact)
  formData.set('benghazi_fact', pricing.benghazi_fact != null && pricing.benghazi_fact !== '' ? pricing.benghazi_fact : pricing.tripoli_fact)
}
